import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {

        apiKey: "AIzaSyBJWSynI3cGHCDXU6JSclOnyjnWQ6662jw",
        authDomain: "portfoliodennis-a4f82.firebaseapp.com",
        projectId: "portfoliodennis-a4f82",
        storageBucket: "portfoliodennis-a4f82.appspot.com",
        messagingSenderId: "494332014285",
        appId: "1:494332014285:web:bc2c32a0e7cc7add294384",
        measurementId: "G-P9BJXKM1N1"

};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

